import { Button, Checkbox } from "antd";
import { FilterFilled } from "@ant-design/icons";
import { useState } from "react";
import { FacilityCategoryNote } from "src/api/facility";

interface CategoryDropdownProps {
  facilityNotes: FacilityCategoryNote[];
  categoriesVisible: Record<string, boolean>;
  updateCategoryVisible: (categoryId: string, checked: boolean) => void;
  onClearAll: () => void;
  onSelectAll: () => void;
}
export function CategoryDropdown({
  facilityNotes,
  categoriesVisible,
  updateCategoryVisible,
  onClearAll,
  onSelectAll,
}: CategoryDropdownProps) {
  const [isClearAll, setIsClearAll] = useState(true);
  const [filterVisible, setFilterVisible] = useState(false);

  const toggleFilter = () => setFilterVisible((prevState) => !prevState);

  const clearAllCheckbox = () => {
    setIsClearAll(false);
    onClearAll();
  };

  const selectAllCheckbox = () => {
    setIsClearAll(true);
    onSelectAll();
  };

  return (
    <div className="facility-notes-filter">
      <div className="notes-filter-action">
        {/* FIXME: Automatically disabled during ESLint config update */}
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
        <label>Notes</label>
        <Button className="category" onClick={toggleFilter}>
          <span>Filter By Category</span>
          <FilterFilled />
        </Button>
      </div>
      {filterVisible && (
        <div className="facility-notes-filter-dropdown">
          <div>
            {facilityNotes.map((item) => (
              <Checkbox
                key={item.categoryId}
                value={item.category}
                checked={categoriesVisible[item.categoryId]}
                onChange={(event) => updateCategoryVisible(item.categoryId, event.target.checked)}
              >
                {item.category}
              </Checkbox>
            ))}
          </div>
          {isClearAll ? (
            <Button className="border-less-btn" onClick={clearAllCheckbox}>
              Clear All
            </Button>
          ) : (
            <Button className="border-less-btn" onClick={selectAllCheckbox}>
              Select All
            </Button>
          )}
        </div>
      )}
    </div>
  );
}
